import React from "react";
import { normalizeCnpj } from "@agnes/ui";
import { useEmpregadoresStore } from "@/stores/useEmpregadoresStore";

/** Razão social pelo CNPJ da rubrica (exato ou pela raiz), a partir das empresas do usuário. */
export function useNomesEmpregadores(): (cnpj: string | null) => string | undefined {
  const lista = useEmpregadoresStore((state) => state.lista);

  React.useEffect(() => {
    const { lista: atual, carregando, buscar } = useEmpregadoresStore.getState();
    if (!atual.length && !carregando) buscar();
  }, []);

  return React.useMemo(() => {
    const nomes = new Map<string, string>();
    lista.forEach((empregador) => {
      const nome = empregador.socialName || empregador.fantasyName;
      if (!nome) return;
      [empregador.cnpjFilial, empregador.cnpjMatriz].forEach((cnpj) => {
        const chave = normalizeCnpj(String(cnpj ?? ""));
        if (chave && !nomes.has(chave)) nomes.set(chave, nome);
      });
    });
    return (cnpj) => {
      const chave = normalizeCnpj(cnpj ?? "");
      return chave ? (nomes.get(chave) ?? nomes.get(chave.slice(0, 8))) : undefined;
    };
  }, [lista]);
}
